import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  confirmPasswordReset,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import store from "../store";
function authService(app) {
  const auth = getAuth(app);
  return {
    logOut: async () => {
      var result = await signOut(auth)
        .then(() => {
          result = true;
          window.location.href = "/";
        })
        .catch((error) => {
          console.log(error);
          result = false;
        });
      return result;
    },
    createUserWithEmail: async (email, password) => {
      var result = await createUserWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          store.commit("setUser", user);
          return {
            success: true,
            user: user,
          };
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;

          return {
            error: true,
            code: errorCode,
            message: errorMessage,
          };
        });
      return result;
    },

    signInWithEmail: async (email, password) => {
      var result = await signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
          const user = userCredential.user;
          store.commit("setUser", user);
          return {
            success: true,
            user: user,
          };
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          return {
            error: true,
            code: errorCode,
            message: errorMessage,
          };
        });

      return result;
    },
    passwordReset: async (email, url) => {
      try {
        await sendPasswordResetEmail(auth, email, url);
        return { success: true };
      } catch (error) {
        return { success: false, code: error.code, message: error.message };
      }
    },
    newPasswordConfirm: async (code, new_password) => {
      try {
        await confirmPasswordReset(auth, code, new_password);
        return { success: true };
      } catch (error) {
        return { success: false, code: error.code, message: error.message };
      }
    },
    onUserAuthChange: async () => {
      return new Promise((resolve) => {
        onAuthStateChanged(auth, (user) => {
          if (user) {
            store.commit("setUser", user);
          } else {
            store.dispatch("clearData");
          }
          resolve(user);
        });
      });
    },
  };
}

export { authService as default };
